import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})

export class SidebarService {
    private REST_API_SERVER = environment.apiUrl;
   
    constructor(
        private httpClient: HttpClient
    ) {
    }

    getSideMenuData() {
        return this.httpClient.get<any>(
            this.REST_API_SERVER + '/getUserGrantedMenus'
        ).pipe(map((res) => res));
    }

    checkProposalPermission() {
        return this.httpClient.get<any>(
            this.REST_API_SERVER + "/checkproposalpermission"
        ).pipe(
            catchError((error) => {
                return throwError(error);
            })
        );
    }

    checkElogBookPermission() {
        return this.httpClient.get<any>(
            this.REST_API_SERVER + "/checkelogbookpermission"
        ).pipe(
            catchError((error) => {
                return throwError(error);
            })
        );
    }

    checkDashboardPermission() {
        return this.httpClient.get<any>(
            this.REST_API_SERVER + "/checkdashboardpermission"
        ).pipe(
            catchError((error) => {
                return throwError(error);
            })
        );
    }    
}